<div class="rs-es-masonry-element" data-es-masonry-element="">
  <div class="panel clearfix">
    <h3 class="rs-tit6 rs-txt-c1 rs-padding-bottom2">
      {{ 'products.overview.card.alwaysProtected' | translate }}
    </h3>
    <div *ngFor="let option of easyProtectOptions">
      <div class="rs-panel-collapse rs-bg-grey1 clearfix" >
        <div *ngIf="option.name && option.name !== 'Easy Protect' || option.productDescription"  class="rs-entrypoint-container">
          <a href="javaScript:void(0)" class="rs-entrypoint" #entry (click)=openAlwaysProtected(entry.innerText)>
            <span class="rs-entrypoint-title"> {{ option.name || option.productDescription}}</span>
            <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
